import React from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

import Highlightjs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";

const DocsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const InnerContainer = styled.div`
  max-width: 70%;
  height: 100%;
  margin-top: 2em;
  font-family: Oxygen, sans-serif;
  a {
    color: #435fb1;
  }
  @media only screen and (max-width: 776px) {
    max-width: 100%;
    padding: 5px 15px;
  }
`;

const ErrorContainer = styled.div`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: Oxygen, sans-serif;
  background-color: #e74c3c;
  color: #fff;
  border-radius: 4px;
  margin-top: 3em;
  padding: 10px;
`;

export default class DocsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      docsMarkdown: null,
      error: null
    };

    //Initialize Code Highlighiting
    Highlightjs.initHighlighting();
  }

  componentDidMount() {
    const docs = require("../resources/docs/butterfly-editor-v1.0.0.md");
    //Fetch Docs MARKDOWN
    fetch(docs)
      .then(response => {
        return response.text();
      })
      .then(text => {
        this.setState({ docsMarkdown: text, error: null });
      })
      .catch(err => {
        if (err) {
          this.setState({ error: "Cannot load DOCS, Please Try Again!" });
        }
      });
  }

  render() {
    const { docsMarkdown, error } = this.state;
    return (
      <DocsContainer>
        <InnerContainer>
          {error && <ErrorContainer>{error}</ErrorContainer>}
          {!error && <ReactMarkdown source={docsMarkdown} />}
        </InnerContainer>
      </DocsContainer>
    );
  }
}
